import { 
    CHANGE_SEARCH_FIELD, 
    REQUEST_ROBOTS_PENDING,
    REQUEST_ROBOTS_SUCCESS,
    REQUEST_ROBOTS_FAILED,
    CHANGE_ROBOTS
 } from './constants';

// an example of action
export const setSearchField = (text) => ({
    type: CHANGE_SEARCH_FIELD,
    payload: text
})

export const requestRobots = () => (dispatch) => {
    dispatch({type: REQUEST_ROBOTS_PENDING});
    fetch('https://jsonplaceholder.typicode.com/users')
        .then(response=> {
            const robots = response.json();
            console.log(robots);
            return robots;
        })
        .then(data => dispatch( {type: REQUEST_ROBOTS_SUCCESS, payload: data}))
        .catch(error => dispatch({ type: REQUEST_ROBOTS_FAILED, payload: error}))
}

const myArray = ["android", "alien", "robot", "cat", "human"]

export const changeRobots = () => {
    
    const randomElement = myArray[Math.floor(Math.random() * myArray.length)];
    console.log(randomElement);
    return {type:CHANGE_ROBOTS, payload: randomElement};

}